/**
 * 存放开发或构建
 */
// 小易app二维码code图片
import testCodeImg from '@/assets/testCode.png'
import productCodeImg from '@/assets/productCode.png'

export const NODE_ENV = process.env.NODE_ENV === 'production'
  ? 'build'
  : 'dev'

/**
 * 大宗： 资讯
 * 测试环境 和 正式环境 用同一套打包的代码
 *
 * 测试环境需要请求测试的资源
 * 正式环境需要请求正式的资源
 */
export const DEPLOY_ENV =
  window.location.href.includes('//seedtest.ap88.com/') || /* 大宗移动端测试域名 */
  window.location.href.includes('//seedtest.ap-ec.cn/') || /* 外网测试域名 */
  window.location.href.includes('//tmsdev.ap88.com/') || /* tms 测试域名 */
  window.location.href.includes('localhost') || /* 本地 */
  window.location.href.includes('192.168.') /* 测试服务器，本地 */
    ? 'test'
    : 'formal'

/**
 * todo: 添加正式BASE_URL
 * 测试和正式环境可能会使用不同的BASE_URL
*/
export const DEPLOY_BASE_URL = DEPLOY_ENV === 'test'
  ? '/tms/dist'
  : ''

// 跳转到撮合商城url
export const JUMP_URL = DEPLOY_ENV === 'test'
  ? 'http://seedtest.ap-ec.cn/match_web/#/'
  : 'http://seed.ap-ec.cn/match_web/#/'

// 小易app二维码code图片
export const CODE_IMG = DEPLOY_ENV === 'test'
  ? testCodeImg
  : productCodeImg
